import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prod-stock-record",
  "use": "icon-prod-stock-record-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-prod-stock-record\"><path d=\"M116.09,96.53H30.27V92c0-16.56,11.79-30,26.28-30h73.63V20.55l58.48,68.56L181.81,95,139.18,45V71H56.55c-8.26,0-15.19,7.09-16.89,16.54h76.43Z\" /><path d=\"M89.82,199.45,31.34,130.89l6.85-5.84,42.63,50V149h82.63c8.26,0,15.19-7.09,16.89-16.54H107v-9h82.75V128c0,16.56-11.79,30-26.28,30H89.82Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol